import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import {
  blue,
  primarycolor,
  secondaryButtonnBackground
} from '../../../constants/Colors';
import { buttonFont, cardCentering } from '../../../constants/Location';
import CompleteCard from '../../uiParts/CompleteCard';
import CustomSnackbar from '../../uiParts/CustomSnackbar';
import Header from '../../uiParts/Header';

const styles = {
  button: {
    '@media screen and (max-width:480px)': {
      width: 309
    },
    height: 42,
    width: 400
  },
  buttonFont,
  icon: {
    color: blue,
    fontSize: '56px',
    paddingBottom: '24px'
  }
};

const ClientAuthComplete: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.client.registerComplete');
  });
  const navigate = useNavigate();
  const icon = <CheckCircleIcon sx={styles.icon} />;
  const text = t('register.thanksRegistered');
  const description = t('register.thanksRegisteredDesc.client');
  const [open, setOpen] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('');

  const button = (
    <Button
      variant="contained"
      sx={[secondaryButtonnBackground, styles.button]}
      onClick={() => {
        navigate('/client/mypage');
      }}
    >
      <Typography component="div" color={primarycolor} sx={styles.buttonFont}>
        {t('register.toHome')}
      </Typography>
    </Button>
  );

  const [finishStatus, setfinishStatus] = useState(false);
  const [closeButton, setCloseButton] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    if (!finishStatus) {
      e.preventDefault();
      setCloseButton(true);
      setOpen(true);
      setErrorText(t('form.browserBackAlert'));
      window.history.pushState(null, '', window.location.pathname);
      setfinishStatus(false);
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ): void => {
    if (reason === 'clickaway') return;
    setOpen(false);
    setCloseButton(false);
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  return (
    <>
      <Header />
      <Typography sx={cardCentering}>
        <CompleteCard
          icon={icon}
          text={text}
          description={description}
          descFontSize={'14px'}
          button={button}
        />
        <CustomSnackbar
          open={open}
          autoHideDuration={6000}
          onClose={closeButton ? handleClose : () => setOpen(false)}
          text={errorText}
          {...(closeButton && { closeButton: handleClose })}
        />
      </Typography>
    </>
  );
};

export default ClientAuthComplete;
